import React, { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import useGridFilter from '../../../../../system/hooks/useGridFilter';
import Styles from '../Styles/ScanModalStyle.module.scss';
import { ChangeableGrid } from '../../../../../components/grids/changeableGrid/ChangeableGrid';
import { IKizConfirmationData } from '../../../../../libs/coreapi-dto/dirs/kiz';

interface IScanKizConfirmationModalContentProps extends ISelectorGridProps {
    kizConfirmationData: IKizConfirmationData[],
    //setKizConfirmationData: (data: IKizConfirmationData[]) => void,
    selectedItem: IGridRow | undefined,
    setSelectedItem: (data: IGridRow | undefined) => void,
    totalScanCount: number,
    scanCount: number,
    isEditKizs?: boolean,
    styleCell?: boolean,
    plugin: IPluginSettings
}

export const ScanKizConfirmationModalContent: React.FC<IScanKizConfirmationModalContentProps> = (props) => {
    const [totalCount] = useState<number>(0);
    const [gridFilter, dispatchGridFilter] = useGridFilter();

    const isEditKizs: boolean = props.isEditKizs ?? false;

    return (
        <>
            <div className={Styles.InputPanel}>
            </div>
            {
                <ChangeableGrid
                    gridId={uuidv4()}
                    data={props.kizConfirmationData}
                    filter={gridFilter}
                    totalCount={totalCount}
                    plugin={props.plugin}
                    numbering={true}
                    isSortDataReverse={true}
                    hiddenPagination={undefined}
                    selectedItem={props.selectedItem}
                    isShowAll={true}
                    onDoubleClick={(row) => props.onDoubleClick?.(row)}
                    onSelect={(row) => {
                        props.setSelectedItem(row)
                        props.onSelect?.(row)
                    }}
                    onSort={(i) => { dispatchGridFilter({ type: "sort", payload: i.propertyName }) }}
                    onFilterDelete={(i) => { dispatchGridFilter({ type: "deleteColumnFilter", payload: i.propertyName }) }}
                    onPageNumberChange={(n) => { dispatchGridFilter({ type: "changePageNumber", payload: { pageNumber: n } }) }}
                    onNumberPerPageChange={(n) => {
                        dispatchGridFilter({ type: "changeNumberPerPage", payload: { numberPerPage: n } })
                    }}
                    isEditKizs={isEditKizs}
                    //getStyleCell={(processedCell) => props.styleCell === true ? getStyleCell(processedCell): null}
                    searching
                />
                    
            }
        </>
    )
};